import { render, staticRenderFns } from "./containersType.vue?vue&type=template&id=5aa37454&"
import script from "./containersType.vue?vue&type=script&lang=js&"
export * from "./containersType.vue?vue&type=script&lang=js&"
import style0 from "./containersType.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports